body = $('body');


body.on('click', '.DLVLC_zoneGroup_radio', function () {
    id = $(this).val();

    var partner = $('#partner').val();
    var customer = $('#customer').val();
    var agreement = $('#agreement').val();

    if ($('#DLVLC_zoneGroup_' + id).hasClass('openSizeType')) {
        $('#DLVLC_sizeTypeContainer').removeClass('d-none');
        $('#DLVLC_zonesContainer').addClass('d-none');
    } else {
        $('.DLVLC_sizeType_radio').prop('checked', false);
        $('#DLVLC_sizeTypeContainer').addClass('d-none');
        $('#DLVLC_zonesContainer').removeClass('d-none');
        getZones($(this).attr('data-url'), $(this).attr('data-method'), partner, customer, $(this).val(), agreement);
    }
});

body.on('click', '.DLVLC_sizeType_radio', function () {
    var partner = $('#partner').val();
    var customer = $('#customer').val();
    var agreement = $('#agreement').val();

    if ($(this).val() !== '' && $(this).val() !== null) {
        $('#DLVLC_zonesContainer').removeClass('d-none');
        getZones($(this).attr('data-url'), $(this).attr('data-method'), partner, customer, $(this).attr('data-zone-group'), agreement, $(this).val());
    }
});

body.on('change', '.DLVLC_type_input', function () {
    let sessionType = $('.DLVLC_type_input:checked').val();
    console.log(sessionType);
    $('.DLVLC_type_input').each(function (i, v) {
        $('#DLVLC_type_' + $(v).val() + '_wrapper').addClass('d-none');
    });

    $('#DLVLC_type_' + sessionType + '_wrapper').removeClass('d-none');
});

/* vlc part */
body.on('change', '#dlvlc_zone', function () {
    let url = $(this).attr('data-url');
    let method = $(this).attr('data-method');
    let zone = $(this).val();
    let zoneGroup = $('#dlvlc_zone_option_' + $(this).val()).attr('data-zone-group')
    let session = $('#session').val();
    let selectedZone = 'zone_1';
    if ($(this).val()) {
        getDLVLCZone(url, method, zone, zoneGroup, session, selectedZone);
    } else {
        $('#DLVLC_zone_info_wrapper').html('')
    }
});

function getDLVLCZone(url, method, zone, zoneGroup, session, selectedZone) {
    var agreement = $('#agreement').val();
    $.ajax({
        url: url,
        type: method,
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        dataType: 'json',
        data: {
            selectedZone: selectedZone,
            session: session,
            zoneGroup: zoneGroup,
            zone: zone,
            agreement: agreement,
        },
        success: function (data) {
            $('#DLVLC_zone_info_wrapper').html(data.html);
            KTImageInput.createInstances();
        },
        error: function (err) {
            $('.ajaxFormError').remove();
            if (err.status == 422) { // when status code is 422, it's a validation issue

                $('#success_message').fadeIn().html(err.responseJSON.message);
                // display errors on each form field
                $.each(err.responseJSON.errors, function (i, error) {
                    var el = $(document).find('[name="' + i + '"]');
                    //el.after($('<div class="ajaxFormError mt-1 w-100 toast mb-2 d-flex align-items-center text-white bg-danger border-0" role="alert" aria-live="assertive" aria-atomic="true"><div class="toast-body"><div class="d-flex align-items-center"><i class="fas fa-danger mr-1"></i>' + error[0].replace(i.replace('_', ' '), el.attr('data-title')) + '</div></div></div>'));
                    el.after($('<div class="ajaxFormError alert alert-danger mt-2"><span class="svg-icon svg-icon-danger svg-icon-2hx"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="black"/><rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="black"/><rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="black"/></svg></span><div class="d-flex flex-column"><h4 class="mb-1 text-dark">Alerta</h4><span>' + error[0].replace(i.replace('_', ' '), el.attr('data-title')) + '</span></div></div>'));
                    //el.after($('<span class="alert-error">'+error[0].replace(i.replace('_', ' '), el.attr('data-title'))+'</span>'));
                });
            }
        },
        complete: function () {
            $('button[data-kt-indicator="on"]').removeAttr('data-kt-indicator');
        }
    });
}
